module.exports = __webpack_public_path__ + "toBride2-we-g-w.0fb9640b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-g-w.jpg
// module id = wfyO
// module chunks = 0